import { RENTABLE_ITEMS_URLS } from 'constants/urls'

export const RENTABLE_ITEMS = RENTABLE_ITEMS_URLS
  ? RENTABLE_ITEMS_URLS.RENTABLE_ITEMS
  : ''
export const VIEW_RENTABLE_ITEM = RENTABLE_ITEMS_URLS
  ? RENTABLE_ITEMS_URLS.VIEW_RENTABLE_ITEM
  : ''
export const EDIT_RENTABLE_ITEM = RENTABLE_ITEMS_URLS
  ? RENTABLE_ITEMS_URLS.EDIT_RENTABLE_ITEM
  : ''
